import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormLabel from '@material-ui/core/FormLabel'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import { tableTypesMatcher } from 'utils/labelMatcher'
const styles = theme => ({
  formControl: {
    margin: `0 ${theme.spacing.unit}px`,
    width: 160
  },
  group: {
    margin: `${theme.spacing.unit}px 0`
  }
})

class TableModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    table: PropTypes.object,
    updateTable: PropTypes.func,
    createTable: PropTypes.func,
    tableTypes: PropTypes.object.isRequired,
    tableIds: PropTypes.array,
    hideModal: PropTypes.func
  }
  static defaultProps = {
    tableIds: []
  }
  state = {
    table: {
      num: 0,
      type: ''
    },
    isValid: false,
    errors: {}
  }
  updateState = nextState => {
    let isValid = true
    let errors = {}
    const { table } = nextState
    if (Number(table.num) < 0) {
      isValid = false
      errors.num = 'Numéro de table non valide'
    } else if (this.props.tableIds.includes(Number(table.num))) {
      isValid = false
      errors.num = 'Le numéro de table existe déjà'
    }

    if (table.type === '') {
      isValid = false
      errors.type = 'Ce champs est requis'
    }
    if (isValid && this.props.table) {
      isValid = !_.isEqual(table, this.props.table)
    }
    this.setState({ ...nextState, isValid, errors })
  }
  handleKeyChanged = name => e => {
    const value = e.target.value < 0 ? 0 : e.target.value
    this.updateState({
      ...this.state,
      table: { ...this.state.table, [name]: value }
    })
  }
  handleTableChange = name => (e, value) => {
    this.updateState({
      ...this.state,
      table: { ...this.state.table, [name]: value }
    })
  }
  handleOnCreate = () => {
    const { table } = this.state
    this.props.createTable(table.type, table.num)
  }
  handleOnUpdate = () => {
    const { table } = this.state
    const changes = { ...table }
    this.props.updateTable(this.props.table, changes)
  }
  renderRadioGroup = classes => {
    const { tableTypes } = this.props
    return (
      <RadioGroup
        aria-label="Type de table"
        name="tableType"
        className={classes.group}
        value={this.state.table.type}
        onChange={this.handleTableChange('type')}>
        {Object.keys(tableTypes).map(
          key =>
            tableTypes[key] === true && (
              <FormControlLabel
                key={key}
                value={key}
                control={<Radio />}
                label={tableTypesMatcher(key)}
              />
            )
        )}
      </RadioGroup>
    )
  }
  componentDidMount() {
    if (this.props.table) {
      let nextState = { table: { ...this.props.table } }
      this.updateState({ ...this.state, ...nextState })
    }
  }
  render() {
    const { classes } = this.props
    const { table, errors, isValid } = this.state
    const isCreate = !this.props.table
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={isCreate ? this.handleOnCreate : this.handleOnUpdate}
        title={isCreate ? 'Ajouter une table' : `Editer ${table.name}`}
        okDisabled={!isValid}>
        <Grid container direction="row" alignItems="center" justify="center">
          <Grid
            container
            direction="column"
            alignItems="center"
            justify="center"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                id="name"
                error={!!errors.num}
                helperText={errors.num || null}
                disabled={!isCreate}
                required
                label="Table n°"
                onChange={this.handleKeyChanged('num')}
                className={classes.formControl}
                value={Number(table.num)}
                type="number"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="center"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} hidden={{ mdUp: true }}>
              <Divider />
            </Grid>
            <Grid item>
              <FormControl
                error={!!errors.type}
                fullWidth
                component="fieldset"
                required
                className={classes.formControl}>
                <FormLabel component="legend">Type de table</FormLabel>
                {this.renderRadioGroup(classes)}
                <FormHelperText>
                  {errors.type ? errors.type : null}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(TableModal)



// WEBPACK FOOTER //
// ./src/routes/Admin/Tables/components/TableModal.js